import { FC, memo } from 'react';
import styles from './index.module.scss';
import { useRequest } from 'ahooks';
import {
  apiV2ElectricMapDataAlarmCountPost,
  V2ElectricMapConfigOverviewDetailPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import titleIcon from '@/assets/images/title_icon.png';

interface AlarmCountBoxProps {
  configDetail?: V2ElectricMapConfigOverviewDetailPostResponse | undefined;
}

const AlarmCountBox: FC<AlarmCountBoxProps> = ({ configDetail }) => {
  const { data: alarmData, loading: loading } = useRequest(() =>
    apiV2ElectricMapDataAlarmCountPost({}).then(res => {
      return res;
    })
  );

  return (
    <div
      className={styles.container}
      onClick={() =>
        window.open(
          `/device/alarm/record?startTime=${alarmData?.startTime}&endTime=${alarmData?.endTime}&labelIds=${configDetail?.labelIds}`,
          '_blank'
        )
      }
    >
      <div className={styles.titleRow}>
        <img src={titleIcon} alt="" />
        <div>近七日未恢复报警</div>
      </div>
      <div className={styles.alarmBox}>
        {/* 第一行：最高级、高级、中级 */}
        <div className={styles.rowTop}>
          <div className={styles.highest}>
            <div className={styles.num}>{alarmData?.topHighAlarmNum ?? 0}</div>
            <div className={styles.text}>最高级</div>
          </div>
          <div className={styles.high}>
            <div className={styles.num}>{alarmData?.highAlarmNum ?? 0}</div>
            <div className={styles.text}>高级</div>
          </div>
          <div className={styles.middle}>
            <div className={styles.num}>{alarmData?.middleAlarmNum ?? 0}</div>
            <div className={styles.text}>中级</div>
          </div>
        </div>
        {/* 第二行：低级、最低级 */}
        <div className={styles.rowBottom}>
          <div className={styles.low}>
            <div className={styles.num}>{alarmData?.lowerAlarmNum ?? 0}</div>
            <div className={styles.text}>低级</div>
          </div>
          <div className={styles.lowest}>
            <div className={styles.num}>{alarmData?.earlyWarningAlarmNum ?? 0}</div>
            <div className={styles.text}>最低级</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(AlarmCountBox);
